<!-- 填写销毁回执 -->
<template>
    <div class="store-modal-content">
        <div class="data_action_form">
            <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
                <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val) => {showTabs = val}">
                    <template slot="tabs" slot-scope="scope">
                        <div class="table_content_box">
                            <!-- 主信息 -->
                            <div v-if="scope.index == 0">
                                <el-form label-width="120px" id="mainInfo" class="baseForm" :model="sendDataInfo" ref="sendDataInfo" size="mini" :show-message="false">
                                    <el-row v-if="dataActionBox.actionType != 2">
                                        <template v-for="(formOneValue, formOneKey) in scope.row.jurconfigform">
                                            <el-form-item v-if="formOneValue.isShow == 1" :key="formOneKey" :prop="formOneValue.entityField"
                                                          :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []">
                                                <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)"></label>
                                                <!-- 日期 -->
                                                <df-date v-if="formOneValue.fieldType == 'date'" v-model="sendDataInfo[formOneValue.entityField]"
                                                         @keyup.enter.native="nextFocus(formOneValue.isIndex, formOneValue.focusField)" :isShowLong="false"
                                                         :isdisabled="formOneValue.isChange == 0 || (dataActionBox.actionType==1&&formOneValue.isUpdate == 0)">
                                                </df-date>
                                                <!-- 检索方案 -->
                                                <el-tooltip v-else-if="formOneValue.fieldType == 'search'" class="item"
                                                            :disabled="(sendDataInfo[formOneValue.entityField] == null || sendDataInfo[formOneValue.entityField] == '' ? true : false) || sendDataInfo[formOneValue.entityField].length <= 9"
                                                            effect="dark" :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                                                    <el-input clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                              @keyup.enter.native="openSearch(formOneValue.searchId, formOneValue.isIndex, formOneValue.entityField, formOneValue.setField, formOneValue.focusField)"
                                                              :disabled="formOneValue.isChange == 0 || (dataActionBox.actionType==1&&formOneValue.isUpdate == 0)">
                                                        <el-button @click="openSearch(formOneValue.searchId, formOneValue.isIndex, formOneValue.entityField, formOneValue.setField, formOneValue.focusField)" slot="append"
                                                                   icon="el-icon-search" :disabled="formOneValue.isChange == 0 || (dataActionBox.actionType==1&&formOneValue.isUpdate == 0)">
                                                        </el-button>
                                                    </el-input>
                                                </el-tooltip>
                                                <!-- formatter下拉选   :automatic-dropdown="true"-->
                                                <el-select clearable size="mini" v-else-if="formOneValue.fieldType == 'formatter'" @visible-change="selectChange"
                                                           :disabled="formOneValue.isChange == 0 || (dataActionBox.actionType==1&&formOneValue.isUpdate == 0)" @change="$forceUpdate()"
                                                           v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择">
                                                    <el-option v-for="item in JSON.parse(formOneValue.formatterContent)" :key="item.key" :label="item.key" :value="item.value">
                                                    </el-option>
                                                </el-select>
                                                <div v-else-if="formOneValue.entityField == 'dumAnnex'">
                                                    <input style="display: none;" type="file" id="recordExcel" multiple name="recordExcel" @change="(e) => { fileUpload(1,e.target.files, e.target.files.length, 0, e) }" />
                                                    <ul v-if="sendDataInfo[formOneValue.entityField]" class="upload">
                                                        <li v-for="(val,key) in sendDataInfo[formOneValue.entityField].split(',')" :key="key">
                                                            <i class="el-icon-error del" @click="delRemove(1,key)"></i>
                                                            <cusImage style="width: 40px; height: 40px;" :src="`${imgUrl}/${val}`" :preview-src-list="[`${imgUrl}/${val}`]">
                                                            </cusImage>
                                                        </li>
                                                        <li>
                                                            <label for="recordExcel" class="image_label">
                                                                <i class="el-icon-plus icon"></i>
                                                            </label>
                                                        </li>
                                                    </ul>
                                                    <ul v-else class="upload">
                                                        <li>
                                                            <label for="recordExcel" class="image_label">
                                                                <i class="el-icon-plus icon"></i>
                                                            </label>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <!-- 账期 -->
                                                <el-input @keyup.enter.native="nextFocus(formOneValue.isIndex)" type="number" v-else-if="formOneValue.entityField == 'credit'"
                                                          :disabled="formOneValue.isChange == 0 || (dataActionBox.actionType==1&&formOneValue.isUpdate == 0)" v-model="sendDataInfo[formOneValue.entityField]"
                                                          :maxlength="$store.state.inputLength"></el-input>
                                                <!-- string类型 -->
                                                <el-input @keyup.enter.native="nextFocus(formOneValue.isIndex, formOneValue.focusField)" v-else
                                                          :disabled="formOneValue.isChange == 0 || (dataActionBox.actionType==1&&formOneValue.isUpdate == 0)" v-model.trim="sendDataInfo[formOneValue.entityField]"
                                                          :maxlength="$store.state.inputLength"></el-input>
                                            </el-form-item>
                                        </template>
                                    </el-row>
                                    <el-row v-if="dataActionBox.actionType == 2">
                                        <template v-for="(formOneValue, formOneKey) in scope.row.jurconfigform">
                                            <el-form-item v-if="formOneValue.isShow == 1" :key="formOneKey">
                                                <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField) + ':'"></label>
                                                <span v-if="formOneValue.isRift == 1">
                                                    <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{
                                          sendDataInfo[formOneValue.entityField]
                                       }}</a>
                                                </span>
                                                <span v-else-if="formOneValue.fieldType == 'date'">
                                                    <span v-if="sendDataInfo[formOneValue.entityField]">
                                                        {{ $common.getLocalTime(sendDataInfo[formOneValue.entityField]) }}
                                                    </span>
                                                </span>
                                                <span v-else-if="formOneValue.entityField == 'isWms'">{{ sendDataInfo.isWms == 1 ?
                                       '是' : '否' }}</span>
                                                <span v-else-if="formOneValue.fieldType == 'formatter'">{{
                                       getValue(sendDataInfo[formOneValue.entityField],
                                          formOneValue.entityField, formOneValue.fieldType,
                                          formOneValue.formatterContent) }}</span>
                                                <span v-else>{{ sendDataInfo[formOneValue.entityField] }}</span>
                                            </el-form-item>
                                        </template>
                                    </el-row>
                                </el-form>
                            </div>
                        </div>
                    </template>
                </v-tabs>
            </el-card>
        </div>
        <div class="dialog-footer">
            <el-button @click="drawerCancel">取 消</el-button>
            <el-button type="primary" @click="sendDataAction()">保 存</el-button>
        </div>
        <!-- 检索方案 -->
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body="true" :append-to-body="true" @close="closeChild">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
    </div>
</template>

<script>
export default {
    props: ["actionData"],
    name: "submitReportModal",
    data() {
        return {
            dataActionBox: {
                actionType: 0, // 0新增，1修改
            },
            sendDataInfo: {},
            formDataList: [],
            mxForm: [],
            tabForm: [],
            footForm: [],
            detaislDataInfo: {},
            inputel: [],
            showTabs: "",
            DialogVisible: false, //判断是否打开检索方案弹框
            seTitle: "", //检索方案的名称
            seType: "", //检索方案查询条件字段
            seIndex: 0,
            seWidth: "", //检索方案弹框的宽度
            seTitle: "", //检索方案的名称
            sField: "", //赋值字段
            fField: "",
            parentSearchData: {}, //检索方案补充的查询列表的查询条件
            imgUrl: "", //图片显示根路径
            requesUrl: "",
            token: {
                token: sessionStorage.getItem("token"),
            },
        }
    },
    methods: {
        //删除随货通行
        delRemove(val, key) {
            switch (val) {
                case 1://附件
                    var arr = this.sendDataInfo.dumAnnex.split(",")
                    arr.splice(key, 1)
                    this.sendDataInfo.dumAnnex = arr.join()
                    break;
                default:
                    break;
            }

        },
        //上传随货同行 2 上传质检 1
        async fileUpload(val, files, length, index, e) {
            if (length - 1 >= index) {
                const params = {
                    file: files[index]
                }
                const response = await this.$http.uploadFile(params, true)
                if (response.status == 200) {
                    if (val == 1) {//附件
                        var arr = []
                        if (this.sendDataInfo.dumAnnex != null && this.sendDataInfo.dumAnnex != '' && this.sendDataInfo.dumAnnex != null) {
                            arr = this.sendDataInfo.dumAnnex.split(',')
                        }
                        arr.push(response.result[0].fileUrl)
                    }
                    this.sendDataInfo.dumAnnex = arr.join()
                    this.fileUpload(val, files, length, index + 1, e)
                } else {
                    e.target.value = ""
                    this.$message.error(response.message)
                }
            } else {
                e.target.value = ""
            }
        },
        imgur() {
            this.requesUrl = this.$store.getters.getConfig.requestUrl;
            this.imgUrl = this.$store.getters.getConfig.imgUrl;
        },
        // 输入框切换焦点
        nextFocus(index, fField) {
            if (fField == "keydown") {
                this.addDetail("sendDataInfo");
                return;
            }
            var aindex = index + 1;
            if (
                this.inputel[aindex].value != "" ||
                this.inputel[aindex].disabled
            ) {
                this.nextFocus(aindex);
                return;
            }
            this.$nextTick(() => {
                this.inputel[aindex].focus();
            });
        },

        // 初始化焦点
        initFocus() {
            for (let index = 0; index < this.inputel.length; index++) {
                if (this.inputel[index].value == "") {
                    this.inputel[index].focus();
                    break;
                }
            }
        },
        // 获取主表单所有input
        getMainInput() {
            var el = document.getElementById("mainInfo");
            console.log(el);

            if (el) this.inputel = el.getElementsByTagName("input");
            console.log(this.inputel);

        },
        async openBox() {
            this.formDataList = this.actionData.formData;
            this.showTabs = this.actionData.formData[0].jciName;
            var oldData = this.actionData.oldData;
            this.filterMainField();
            if (this.actionData.cate == 0) {
                this.showTabs = "新增"
                this.sendDataInfo.dumCode = this.actionData.oldData.dumCode;
                this.sendDataInfo.dumId = this.actionData.oldData.dumId;
                this.sendDataInfo.dumPlace = this.actionData.oldData.dumPlace;
                this.sendDataInfo.dumMethod = this.actionData.oldData.dumMethod;
            } else {
                // 回显数据
                this.dataActionBox.boxTitle = "编辑";
                var dataInfo = JSON.parse(JSON.stringify(oldData));
                for (let key in dataInfo) {
                    this.$set(this.sendDataInfo, key, dataInfo[key])
                }
                this.sendDataInfo.dumCode = oldData.dumCode;
                this.sendDataInfo.dumId = oldData.dumId;
            }
            this.dataActionBox.actionType = this.actionData.cate
            this.$nextTick(() => {
                setTimeout(() => {
                    this.initFocus();
                }, 16.7);
            });
        },
        // 过滤表单不同类型
        filterMainField() {
            var mainFormList = [];
            this.formDataList.forEach((item) => {
                if (item.jciType == 1) {
                    mainFormList.push(item);
                } else if (item.jciType == 2) {
                    this.mxForm = JSON.parse(JSON.stringify(item));
                    this.mxForm.jurconfigform.forEach((item1) => {
                        if (item1.fieldType == "number") {
                            this.$set(this.detaislDataInfo, item1.entityField, 0);
                        } else if (item1.fieldType == "search" && item1.setField) {
                            var arr = item1.setField.split(",");
                            arr.forEach((item2) => {
                                this.$set(this.detaislDataInfo, item2, "");
                            });
                        } else {
                            this.$set(this.detaislDataInfo, item1.entityField, "");
                        }
                    });
                } else if (item.jciType == 3) {
                    this.footForm = JSON.parse(JSON.stringify(item.jurconfigform));
                }
            });
            mainFormList.forEach((key, i) => {
                this.tabForm[i] = JSON.parse(JSON.stringify(key));
                this.tabForm[i].jurconfigform = [];
                var index1 = 0
                for (let index = 0; index < key.jurconfigform.length; index++) {
                    if (key.jurconfigform[index].isShow == 1) {
                        key.jurconfigform[index].isIndex = index1
                        index1++
                    }
                    this.tabForm[i].jurconfigform.push(key.jurconfigform[index]);

                }
            });
            var obj = this.$common.filterMainFields(this.formDataList, [], mainFormList[0]);
            for (let key in obj) {
                this.$set(this.sendDataInfo, key, obj[key]);
            }
            this.sendDataInfo.dumActDate = this.$moment().valueOf()
        },
        //检索方案获取的数据清除
        clear(val) {
            if (val) {
                var arr = val.split(",")
                arr.forEach((item) => {
                    this.$set(this.getRequestData, item, "")
                })
            }
        },
        //获取检索方案弹框宽度
        getSeWidth(e) {
            this.seWidth = e + "%"
        },
        //获取检索方案弹框名称
        getSearchName(e) {
            this.seTitle = e
        },
        // 检索Id, 索引(表格中), 标识
        openSearch(sId, index, type, sField, fField) {
            this.seId = sId //检索方案Id
            this.fField = fField //获取焦点
            this.sField = sField //赋值字段
            this.DialogVisible = true //判断是否打开弹框
            this.seType = type
            this.seIndex = index
        },
        //检索方案返回的数据
        changeInputModel(val) {
            if (val != "" || val != undefined) {
                console.log(val, 'val');
                if (this.seType == 'dumActPersonName') {
                    this.sendDataInfo.dumActPerson = val.opmId
                    this.sendDataInfo.dumActPersonName = val.opmName
                } else if (this.seType == 'dumMonPersonName') {
                    this.sendDataInfo.dumMonPerson = val.opmId
                    this.sendDataInfo.dumMonPersonName = val.opmName
                } else if (this.seType == 'dumEntPersonName') {
                    this.sendDataInfo.dumEntPerson = val.opmId
                    this.sendDataInfo.dumEntPersonName = val.opmName
                } else {
                    this.paramValue(val)
                }
            }
            this.DialogVisible = false
            this.$nextTick(() => {
                this.nextFocus(this.seIndex, this.fField);
            });
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(",")
            arr.forEach((item) => {
                this.sendDataInfo[item] = val[item]
            })

        },
        async sendDataAction() {
            // 表单验证
            this.$refs.sendDataInfo.validate(async (valid) => {
                if (valid) {
                    let sendData = JSON.parse(JSON.stringify(this.sendDataInfo))
                    let responseData
                    // 如果是新增
                    if (this.dataActionBox.actionType == 0) {
                        responseData = await this.$http.submitReport(sendData)
                    }
                    if (responseData.status == 200) {
                        this.$message({
                            message: "操作成功",
                            type: "success",
                        })
                        this.$emit("drawerCancel", true)
                        this.$emit("toDetail", responseData.result)
                    } else {
                        this.$message({
                            message: responseData.message,
                            type: "error",
                        })
                    }
                } else {
                    this.$message({
                        message: "请填写必填项",
                        type: "error",
                    })
                    return false
                }
            })
        },
        closeChild() {
            addEventListener('keyup', this.keyUp)//创建监听键盘事件
        },
        drawerCancel() {
            this.$confirm("确认关闭弹窗吗？未保存的数据将丢失。", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                this.$emit("drawerCancel", false)
            }).catch(() => { })
        },



    },
    created() {
        this.imgur();
        this.openBox()
    },
    updated() {
        this.getMainInput();
    }, //生命周期 - 更新之后
}
</script>
<style scoped>
.store-modal-content {
    padding: 20px;
    max-height: 70vh;
    overflow-y: auto;
}

.data_action_form {
    width: 100%;
}

.dialog-footer {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    background: #fff;
    height: 46px;
    padding: 5px 10px;
    margin-top: 20px;
    border-top: 1px solid #eee;
}
.upload {
    width: 200px;
    list-style: none;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}
.upload li {
    position: relative;
    width: 42px;
    height: 42px;
    margin-right: 5px;
    margin-bottom: 5px;
    border: 1px solid #dedede;
}
.upload .active_li {
    border: none;
}
.image_label {
    display: block;
    width: 42px;
    height: 42px;
}
.upload li:last-child {
    border: none;
}
.upload li:last-child .image_label {
    border: 1px dashed #838383;
}
.upload li:last-child .image_label:hover {
    border: 1px dashed #409eff;
    cursor: pointer;
}
.upload li:last-child:hover .icon {
    color: #409eff;
}
.upload li .icon {
    color: #838383;
    font-size: 20px;
    margin: 10px 0 0 10px;
}
.del {
    display: none;
    position: absolute;
    top: 0px;
    right: 0px;
    font-size: 14px;
    z-index: 99;
    cursor: pointer;
}

.del:hover {
    color: #409eff;
}

.upload li:hover .del {
    display: inline-block;
}
::v-deep .el-image__error {
    font-size: 7px;
}
::v-deep .cus-image {
    width: 40px !important;
    height: 40px !important;
}
::v-deep .cus-image img {
    width: 40px !important;
    height: 40px !important;
}
</style>
